export default __webpack_public_path__ + "static/media/sub-service-icon.4149b35c.svg";